import React, { useState } from "react";
import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";
import { PARTNERS } from "../../data/mock";

const PartnerLogo = ({ name, slug, size = "h-9" }) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <span className="font-display font-semibold text-xl text-slate-400 whitespace-nowrap select-none">
        {name}
      </span>
    );
  }
  return (
    <img
      src={`https://cdn.simpleicons.org/${slug}/94a3b8`}
      alt={name}
      title={name}
      onError={() => setFailed(true)}
      className={`${size} w-auto object-contain opacity-70 hover:opacity-100 transition-opacity`}
    />
  );
};

const Partners = () => {
  const { lang } = useLanguage();
  const t = translations[lang].partners;
  const loop = [...PARTNERS, ...PARTNERS, ...PARTNERS];

  return (
    <section className="bg-navy-900 border-y border-white/10 py-10">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.25em] text-slate-400 mb-8">
          {t.title}
        </p>
        <div className="relative overflow-hidden marquee-wrap" data-testid="partners-marquee">
          <div className="flex items-center gap-16 w-max animate-marquee">
            {loop.map((p, i) => (
              <PartnerLogo key={`${p.slug}-${i}`} name={p.name} slug={p.slug} size={p.size} />
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-navy-900 to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-navy-900 to-transparent" />
        </div>
      </div>
    </section>
  );
};

export default Partners;
